import script from "./aborigines.vue?vue&type=script&setup=true&lang=js"
export * from "./aborigines.vue?vue&type=script&setup=true&lang=js"

import "./aborigines.vue?vue&type=style&index=0&id=33cf3999&lang=scss"

const __exports__ = script;

export default __exports__